// extracted by mini-css-extract-plugin
module.exports = {"price":"RL-z","onSale":"SL-z"};